<template>
  <span class='breathText'>
{{num}}
  </span>
</template>

<script>
  //vuex
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  //通信总线
  import Bus from 'common/js/bus.js'


  export default {
    name: "breathText",
    data() {
      return {}
    },
    props: ['num'],
    computed: {},
    watch: {},
    methods: {},
    filters: {},
    components: {},
    activated() {
    },
    mounted() {
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .breathText
    border 1px solid #00f
</style>


// WEBPACK FOOTER //
// src/components/personal/breathText.vue